import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { StepperModule } from 'primeng/stepper';
import { InputTextModule } from 'primeng/inputtext';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';
import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { ImageModule } from 'primeng/image';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CompanyModel } from '../../model/company.model';
import { DocumentDriverModel } from '../../model/document.driver.model';
import { DocumentVehicleModel } from '../../model/document.vehicle.model';
import { DriverVehicleResultModel } from '../../model/driver-vehicle-result.model';
import { compressImage } from '../../shared/utils/image-compression.util';
import { isAllowedUploadType } from '../../shared/utils/file-type-validator.util';
import { CoreApiService } from '../../core/service/core-api-service';
import { AppService } from '../../core/service/app.service';
import { JsonRequest } from '../../model/jsonRequest.model';
import { properties } from '../../../environments/properties';
import { ImageEnum } from '../../model/Enums/image.enum';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-registro-procpecto',
  standalone: true,
  imports: [
    StepperModule,
    ButtonModule,
    InputTextModule,
    ToggleButtonModule,
    CommonModule,
    FormsModule,
    FloatLabelModule,
    ReactiveFormsModule,
    TableModule,
    FileUploadModule,
    ImageModule,
    DropdownModule,
    CheckboxModule,
    RadioButtonModule,
    IconFieldModule,
    InputIconModule,
  ],
  templateUrl: './registro-procpecto.component.html',
  styleUrl: './registro-procpecto.component.css',
})
export class RegistroProcpectoComponent implements OnInit {
  titulo: string = 'Crear Conductor';
  step1_titulo: string = 'Datos del Conductor';
  step2_titulo: string = 'Datos de la Compañia';
  step3_titulo: string = 'Datos del Vehículo';
  step4_titulo: string = 'Documentación';
  step5_titulo: string = 'Documentos del Vehículo';
  step6_titulo: string = 'Hecho';
  active: number = 0;
  selectCompany!: CompanyModel;
  ltsCompany!: CompanyModel[];
  ltsDocument: DocumentDriverModel[] = [];
  ltsDocumentVehicle: DocumentVehicleModel[] = [];
  ltsTypeDocumentVehicle: any[] = [];
  selectedTypeDocumentVehicle: any | undefined;
  vehicleConflict: boolean = false;
  createdVehicleId: number | null = null;
  resultMessage: string = '';
  loading: boolean = false;
  ingredient!: string;
  formConductor = new FormGroup({
    dri_name: new FormControl('', Validators.required),
    dri_last_name: new FormControl('', Validators.required),
    dri_term_conditions: new FormControl('', Validators.required),
    dri_phone: new FormControl('', Validators.required),
    dri_password: new FormControl('', Validators.required),
  });
  formVehiculo = new FormGroup({
    veh_plate: new FormControl('', Validators.required),
    veh_num_registration: new FormControl('', Validators.required),
    veh_model: new FormControl('', Validators.required),
    veh_brand: new FormControl('', Validators.required),
    veh_quantity_person: new FormControl('', Validators.required),
    veh_anio: new FormControl('', Validators.required),
    veh_color: new FormControl('', Validators.required),
    veh_inspection: new FormControl('', Validators.required),
    veh_secure: new FormControl('', Validators.required),
  });

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    if (this.router.url.includes('registro-exitoso')) {
      this.active = 5;
    } else {
      this.getLtsCompany();
    }
  }

  next(): void {
    if (this.active === 1) {
      if (this.selectCompany === undefined) {
        this.util.mostrarToast(
          'Crear Conductor',
          'Debe seleccionar una compañía',
          3,
        );
      } else {
        this.getLtsTypeDocumentVehicle();
        this.active++;
      }
    } else {
      this.active++;
    }
  }

  back(): void {
    this.active--;
  }
  getLtsCompany(): void {
    const that = this;

    this.loading = true;
    this.apiService.consumirWSGet(
      properties.serviceGetAllCompanyPublic,
      null,
      function (data) {
        that.ltsCompany = data.data;
        that.ltsCompany.forEach((item) => {
          item.estado = item.com_status == 1;
        });
        that.loading = false;
      },
    );
  }

  getLtsTypeDocumentVehicle(): void {
    const body: JsonRequest = {
      data: JSON.stringify({
        typ_type_document: 2,
      }),
      company: this.selectCompany.com_id,
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceGetAllTypeDocument,
      body,
      (data) => {
        this.ltsTypeDocumentVehicle = data.data;
        this.selectedTypeDocumentVehicle = this.ltsTypeDocumentVehicle[0];
      },
    );
  }

  backStart(): void {
    this.active = 0;
  }

  crearDriver(): void {
    let documents = this.ltsDocument;
    let fotoPerfil = this.ltsDocument.filter(
      (item) => item.dri_doc_typ_codigo === 1,
    );
    if (fotoPerfil.length > 0) {
      const that = this;
      const formData = new FormData();
      formData.append(
        'dri_name',
        this.formConductor.get('dri_name')?.value ?? '',
      );
      formData.append(
        'dri_last_name',
        this.formConductor.get('dri_last_name')?.value ?? '',
      );
      formData.append(
        'dri_number_license',
        '',
      );
      formData.append(
        'dri_term_conditions',
        this.formConductor.get('dri_term_conditions')?.value ?? '',
      );
      formData.append(
        'dri_social',
        '',
      );
      formData.append(
        'dri_phone',
        this.formConductor.get('dri_phone')?.value ?? '',
      );
      formData.append(
        'dri_address',
        '',
      );
      formData.append(
        'dri_password',
        this.formConductor.get('dri_password')?.value ?? '',
      );
      formData.append('dri_company', this.selectCompany.com_id.toString());

      formData.append(
        'veh_plate',
        this.formVehiculo.get('veh_plate')?.value ?? '',
      );
      formData.append(
        'veh_num_registration',
        this.formVehiculo.get('veh_num_registration')?.value ?? '',
      );
      formData.append(
        'veh_model',
        this.formVehiculo.get('veh_model')?.value ?? '',
      );
      formData.append(
        'veh_brand',
        this.formVehiculo.get('veh_brand')?.value ?? '',
      );
      formData.append(
        'veh_quantity_person',
        this.formVehiculo.get('veh_quantity_person')?.value ?? '',
      );
      formData.append(
        'veh_anio',
        this.formVehiculo.get('veh_anio')?.value ?? '',
      );
      formData.append(
        'veh_color',
        this.formVehiculo.get('veh_color')?.value ?? '',
      );
      formData.append(
        'veh_inspection',
        this.formVehiculo.get('veh_inspection')?.value == 'true' ? '1' : '0',
      );
      formData.append(
        'veh_secure',
        this.formVehiculo.get('veh_secure')?.value == 'true' ? '1' : '0',
      );

      documents.forEach((doc, index) => {
        formData.append(`file`, doc.file, doc.file.name);
      });

      this.loading = true;
      this.apiService.consumirWSFilePost(
        properties.serviceCreateProspectoWithVehicle,
        formData,
        (data) => {
          if (data.estado === properties.codeOK) {
            const result: DriverVehicleResultModel = data.data;
            that.loading = false;
            that.vehicleConflict = result.vehicleConflict;
            that.createdVehicleId = result.vehicleId;
            that.resultMessage = result.message;
            that.formConductor.reset();
            that.formVehiculo.reset();
            that.ltsDocument = [];
            that.util.mostrarToast(
              'Crear Conductor',
              result.message,
              result.vehicleConflict ? 2 : 1,
            );
            if (result.vehicleConflict) {
              that.active = 5;
            } else {
              that.active = 4;
            }
          } else {
            that.loading = false;
            if (data.mensaje === 'DriverAlreadyExists') {
              that.util.mostrarToast(
                'Crear Conductor',
                'El conductor ya existe',
                4,
              );
            } else {
              that.util.mostrarToast(
                'Crear Conductor',
                data.mensaje || 'Error al crear',
                4,
              );
            }
          }
        },
      );
    } else {
      this.util.mostrarToast(
        'Crear Conductor',
        'Debe tener una foto de perfil',
        3,
      );
    }
  }

  async onUploadAuto(files: File[], fileUpload: any) {
    if (!isAllowedUploadType(files[0], false)) {
      this.util.mostrarToast(
        'Crear Conductor',
        'Formato no permitido. Solo se aceptan imágenes PNG o JPG.',
        4,
      );
      fileUpload.clear();
      return;
    }
    const doc = await compressImage(files[0]);
    const filestring = await this.previewFile(doc);
    if (this.ltsDocument.length > 0) {
      this.ltsDocument[0] = {
        dri_doc_dri_id: 0,
        dri_doc_doc_id: 0,
        dri_doc_company: this.util.returnEmpresa(),
        dri_doc_typ_codigo: ImageEnum.ImageProfile,
        file: doc,
        filstring: filestring,
        typeDocument: { typ_name: 'Foto de Perfil' },
      };
    } else {
      // Si no hay ninguna imagen, agrega el archivo a ltsDocument
      this.ltsDocument.push({
        dri_doc_dri_id: 0,
        dri_doc_doc_id: 0,
        dri_doc_company: this.util.returnEmpresa(),
        dri_doc_typ_codigo: ImageEnum.ImageProfile,
        file: doc,
        filstring: filestring,
        typeDocument: { typ_name: 'Foto de Perfil' },
      });
    }
    fileUpload.clear();
  }

  remeveFile(index: number) {
    this.ltsDocument.splice(index, 1);
  }

  async onUploadAutoVehicle(files: File[], fileUpload: any) {
    if (!isAllowedUploadType(files[0], true)) {
      this.util.mostrarToast(
        'Crear Conductor',
        'Formato no permitido. Solo se aceptan imágenes PNG o JPG o documentos PDF.',
        4,
      );
      fileUpload.clear();
      return;
    }
    const doc = await compressImage(files[0]);
    const filestring = await this.previewFile(doc);
    this.ltsDocumentVehicle.push({
      veh_doc_veh_id: 0,
      veh_doc_doc_id: 0,
      veh_doc_company: this.util.returnEmpresa(),
      veh_doc_typ_id: this.selectedTypeDocumentVehicle.typ_id,
      file: doc,
      filstring: filestring,
      typeDocument: this.selectedTypeDocumentVehicle,
    });
    fileUpload.clear();
  }

  remeveFileVehicle(index: number) {
    this.ltsDocumentVehicle.splice(index, 1);
  }

  guardarDocumentosVehiculo(): void {
    const that = this;
    const finish = () => {
      that.ltsDocumentVehicle = [];
      that.active = 5;
    };

    if (this.ltsDocumentVehicle.length === 0 || this.createdVehicleId === null) {
      finish();
      return;
    }
    const formData = new FormData();
    this.ltsDocumentVehicle.forEach((doc, index) => {
      formData.append(
        `lista[${index}][veh_doc_veh_id]`,
        this.createdVehicleId!.toString(),
      );
      formData.append(
        `lista[${index}][veh_doc_company]`,
        this.util.returnEmpresa().toString(),
      );
      formData.append(
        `lista[${index}][veh_doc_typ_id]`,
        doc.veh_doc_typ_id.toString(),
      );
      formData.append(`lista[${index}].file`, doc.file, doc.file.name);
    });
    this.apiService.consumirWSFilePost(
      properties.serviceFilesVehicle,
      formData,
      (resp) => {
        if (resp.estado !== properties.codeOK) {
          that.util.mostrarToast(
            'Documentos del vehículo',
            'No se pudieron subir todos los documentos',
            4,
          );
        }
        finish();
      },
    );
  }

  previewFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result as string);
        } else {
          reject('Error al leer el archivo');
        }
      };
      reader.onerror = () => {};
    });
  }
}
